import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

// Challenge Winner API

export const challengeWinner = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `challengewinner`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetParticpatedColleges = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `StudentChallenge/getOrganizationChallenge`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const GetClosedChallenegs = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `Challenges/closedchallenges`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetChallenegeWinnerStudent = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `StudentChallenge/getStudentOrganizationChallenge`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetChallengeWinner = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `challengewinner/getChallengeWinner`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error)
            return error;
        });
}

export const GetApproval = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `challengewinner/generateCertificateId`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error)
            return error;
        });
}

export const RankWinners = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `StudentChallenge/getwinners`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error)
            return error;
        });
}
